export default __webpack_public_path__ + "static/media/header.a1d1bb97.png";